/* eslint-disable */
import Api from '@/services/Api'

export default {
  create(data){
    try {
      return Api().post('user/', data);
    }catch(err){
      console.log(err);
      return err
    }
  },
  update(data){
    try {
      return Api().put('user/', data);
    }catch(err){
      console.log(err);
      return err
    }
  },
  deleteRecord(data){
    try {
      return Api().delete('user/', {data});
    }catch(err){
      console.log(err);
      return err
    }
  },
  getAll(){
    try {
      return Api().get('user/');
    }catch(err){
      console.log(err);
      return err
    }
  },
  massStudentFilter(){
    try {
      return Api().get('admin/student/gsheet/mass');
    }catch(err){
      console.log(err);
      return err
    }
  },
    massCreate(){
        try {
            return Api().get('user/gsheet/mass');
        }catch(err){
            console.log(err);
            return err
        }
    },
  getAllUserRoles(){
    try{
      return Api().get('user/role/all');
    }catch(err){
      console.log(err);
      return err
    }
  },
  getAllUserStatus(){
    try{
      return Api().get('user/status/all');
    }catch(err){
      console.log(err);
      return err
    }
  },
  getAdminStudents(adminId){
    try{
      return Api().get('admin/students/?admin_id='+adminId);
    }catch(err){
      console.log(err);
      return err
    }
  },
  addStudent(data){
      try {
          return Api().post('admin/student/', data);
      }catch(err){
          console.log(err);
          return err
      }
  },
  deleteAdminStudent(id){
      try {
          return Api().delete('admin/student/?filter_id='+id);
      }catch(err){
          console.log(err);
          return err
      }
  },
    getUserTypes(){
        try {
            return Api().get('user/types/');
        }catch(err){
            console.log(err);
            return err
        }
    },
    changePassword(data){
        try {
            return Api().post('user/update/', data);
        }catch(err){
            console.log(err);
            return err
        }
    },
}
